module.exports = __webpack_public_path__ + "media/eye-closed.328f76bf.svg";